import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@trukt/query-keys';
import { CustomQueryOptions } from '@trukt/types/CustomQueryOptions';

import { useApiContext } from './ApiProvider';

export const useJobStatusGetQuery = (options?: CustomQueryOptions) => {
  const { truktApi } = useApiContext();

  return useQuery({
    queryKey: queryKeys.job.status.get(),
    queryFn: async () => {
      const response = await truktApi.job.status.get();
      return response.data;
    },
    ...options,
  });
};
